import { ArrowRight, ChevronRight, Clock, Download } from "lucide-react"
import { useState } from "react"

const HomeNotices = () => {
    const [notices, setNotices] = useState([
        {
            "id": 382,
            "title": "\"WALK-IN-INTERVIEW\" FOR ENGAGEMENT OF TEACHERS",
            "category": null,
            "message": null,
            "starts_at_date": "9th February 2026",
            "file_attachment": 1,
            "pinned": 0,
            "starts_at": "2026-01-21 14:20:00",
            "row_id": "697093a4857fe"
        },
    ])

    function handleNoticeClick() {
        const link = document.createElement('a');
        link.href = '/notices/notice-1.pdf';
        link.target = '_blank';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    }

  return (
    <section className="py-5">
        <div className="container">
          <div className="">
            <h2 className="about-title">Notices</h2>
            <div className="about-title-underline"></div>

            <div className="lg:col-span-2">
              <div className="space-y-4">
                {notices && notices.length > 0 && notices.map((notice, index) => index < 4  && (
                  <div
                    key={notice.row_id}
                    className="border-l-4 border-l-blue-500 hover:shadow-md transition-shadow cursor-default"
                    onClick={handleNoticeClick}
                  >
                    <div className="p-6">
                      <div className="py-3 px-4 flex items-start justify-between border border-slate rounded-lg mb-2 hover:bg-white">
                        <div className="flex-1">
                          <div className="flex items-center gap-3 mb-2">
                            {/* <Badge
                              variant={
                                notice.priority === "high"
                                  ? "destructive"
                                  : notice.priority === "medium"
                                    ? "default"
                                    : "secondary"
                              }
                              className="text-xs"
                            >
                              {notice.type}
                            </Badge> */}
                            <span className="text-sm text-gray-500 flex items-center gap-1">
                              <Clock className="h-3 w-3" />
                              {notice.starts_at_date}
                            </span>
                          </div>
                          <h3 className="font-semibold text-gray-900 mb-2">
                            {notice.title}
                          </h3>
                        </div>
                        {
                          notice.file_attachment && !notice.message ?
                          <Download className="h-5 w-5 text-gray-400 flex-shrink-0" /> :
                          <ChevronRight className="h-5 w-5 text-gray-400 flex-shrink-0 transition-transform" />
                        }
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>
  )
}

export default HomeNotices
